import bazar from "Assets/Images/Hero2/bazar.png";
import google from "Assets/Images/Hero2/Google_Play.png";
import web from "Assets/Images/Hero2/webapp.png";
import "./style.css";

const DownloadMerchantApp = ({response}) => {
  return (
    <div className="dl-merchant d-flex  justify-content-start  flex-column ">
      <h2 className="my-5 bg-dap-success text-white text-center p-4">
        دانلود اپلیکیشن ویژه پذیرندگان
      </h2>
      <div className="down-merchant-links  d-flex justify-content-center  align-items-center flex-column ">
        <a
          href="https://cafebazaar.ir/app/com.daapapp.businessrnnew"
          className="mb-3"
          target="_blank"
        >
          <img src={bazar} alt="" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.daapapp.businessrnnew&hl=fa&gl=US"
          className="mb-3"
          target="_blank"
        >
          <img src={google} alt="" />
        </a>
        <a
          href="https://web-business.daapapp.com"
          className="mb-3"
          target="_blank"
        >
          <img src={web} alt="" />
        </a>
      </div>
    </div>
  );
};


export default DownloadMerchantApp;
